import { QUERY_KEYS } from 'constants/constants'
import { usePartnerContext } from '../context'
import { useMutationAndUpdateQuery } from './use-mutation-and-update-query'

export const usePartnerIntegrationCreate = () => {
  const { partner } = usePartnerContext()

  return useMutationAndUpdateQuery({
    queryKey: QUERY_KEYS.partnerIntegrationsByPartner(partner.id),
    mutation: 'createIntegration',
    updater: ({ prevData, response }) => {
      const newData = prevData ? [...prevData] : []
      newData.push(response)

      return newData
    }
  })
}
